export class QuickDispenseResult {
    OrderId: number;
    StatementId: number;
    PatientId: number;
    EncounterId: number;
    PatientTypeId: number;
    InvoiceNet: number;
    RemainingAmount: number;
}
